var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { HDSConfirm } from "@here/hds-react-components/Confirm";
import { ModalPortal } from "../../components/mapModal/ModalPortal";
export var ConfirmDailog = function (props) {
    var className = props.className, children = props.children, renderBody = props.renderBody, confirmDailogStyles = props.confirmDailogStyles, otherProps = __rest(props, ["className", "children", "renderBody", "confirmDailogStyles"]);
    return (_jsx(ModalPortal, { children: _jsxs(HDSConfirm, __assign({ style: __assign({}, confirmDailogStyles), className: className }, otherProps, { children: [renderBody(), children && children] })) }));
};
ConfirmDailog.defaultProps = {
    header: _jsx(_Fragment, {}),
    children: _jsx("div", {}),
    hideCloseBtn: false,
    disableCloseOnOverlayClick: false,
    disableCloseOnEscape: false,
    footer: _jsx(_Fragment, {}),
    renderBody: function () { return _jsx(_Fragment, {}); },
    className: "",
    confirmDailogStyles: {
        "--hds-modal-desktop-large-grid-column": "5 / 9",
        "--hds-modal-desktop-medium-grid-column": "5 / 9",
    },
};
